<template>
  <div class="hello">
    <div id="header">

      <div class="wid_con">
        <div class="top_con">
          <div class="top_logo">
            <a href="https://www.360ping.com/qjyxWeb-user"><img src="https://www.360ping.com/images/pc_logo.png"></a>
            <span>登录系统</span>
          </div>
          <!--<div class="top_menu">
					<ul>
						<li class="cur"><a href="index.html">首页</a></li>
						<li class=""><a href="#">老师</a></li>
						<li class=""><a href="#">家长</a></li>
					</ul>
					 
				</div>-->
        </div>
      </div>



    </div>

    <div class="login-wrap">
      <div class="wrap clearfix">


        <div class="form-box fr loginV2"
          style="display:block;-moz-border-radius: 8px; -webkit-border-radius: 8px; border-radius:8px; position:relative;">
          <!--<ul class="form-tab clearfix">
			    <li class="tab-li cur" style=" width:100%;"><a href="javascript:;" tjjj="passport.login_type.login_name">账号登录</a></li>
			</ul>-->


          <div class="login_title_1" id="dl_title"> {{ switchLoginType ? '手机号登录' : '微信扫码登录' }}</div>

          <div class="login_wx_wz" id="weixinsaoma"> {{ switchLoginType ? '微信扫码登录更便捷' : '手机号和密码登录' }}<i class="icon iconfont icon-solid-arrow"></i></div>
          <div class="login_ewm" id="sm" @click="switchLoginType = !switchLoginType, getCode()"><i
              :class="{icon:true, iconfont:true, 'icon-erweima3':switchLoginType,'icon-diannao1':!switchLoginType}" title="微信扫码登录" style="top: 7px;"></i><img src="https://www.360ping.com/images/dn_bg.png" title="微信扫码登录">
          </div>
          <div class="login_wx_wz" style="display:none;" id="dnzh">手机号和密码登录<i class="icon iconfont icon-solid-arrow"></i>
          </div>
          <div class="login_ewm" id="zh" onclick="denglu(2)" style="display:none;"><i class="icon iconfont icon-diannao1"
              title="账号登录"></i><img src="https://www.360ping.com/images/dn_bg.png" title="账号登录"></div>

          <div class="form-con">


            <!--账号登录 str-->
            <div class="login-normal" style="display:block;" id="zhanghao" v-if="switchLoginType">
              <form id="nameLoginForm" method="post" autocomplete="off" onsubmit="return nameLoginCheck();">
                <div class="form-error" style=""><i></i><label class="text"></label></div>
                <dl class="clearfix">
                  <dt>手机号：</dt>
                  <dd><input type="text" name="loginName" id="normalUser" v-model="text" class="input-text"
                      autocomplete="off" placeholder="请输入手机号"></dd>
                </dl>
                <dl class="top1 clearfix">
                  <dt>密<em></em>码：</dt>
                  <dd><input type="password" name="password" id="normalPassword" v-model="pwd" class="input-text"
                      placeholder="请输入密码">
                  </dd>
                </dl>






                <div class="form-remember">

                  <!-- <input name="rememberName" type="checkbox" id="remUser" class="rem-check" style="display:none;"
                    checked="checked">
                  <span class="rem-box rem-box-r memCheck"><label><input name="rememberMe" type="checkbox" id="remLogin">
                      记住密码</label></span>
                  <a href="../find_password.html" class="forget-pass" tjjj="passport.forget.password">忘记密码？</a> -->

                </div>

                <div class="btn-box clearfix">
                  <input id="normalSubmit" class="btn-settlement" type="button" value="登    录" @click="confirmLogin">

                </div>
                <!--<div class="link-box clearfix" style="display:none">
                            <a href="javascript:;" class="register" tjjj="passport.login.fstreg">新用户注册</a>
                            <a href="find_password.html" class="forget-pass" tjjj="passport.forget.password">忘记密码？</a>
                        </div>-->
              </form>






            </div>
            <!--账号登录-->


            <!--扫码登录 str-->
            <div class="sm_kk" id="saoma00" v-if="!switchLoginType && timeOut">

              <div class="ewm_pic" v-loading="loading">
                <img :src="'data:image/png;base64,' + codeImg" v-if="codeImg">
                <div class="sm_ewm_gq" @click="getCode"><span>二维码已过期<br><input class="btn-shuaxin" type="submit"
                      value="点击刷新"></span></div>

              </div>
              <div class="sm_text" style="text-align: center;padding-left: 0px;">
                <i class="icon iconfont icon-saoma4"></i>
                微信扫一扫，登录安全又快速<br><span>打开微信 &gt; 右上角+ &gt; 扫一扫</span>
              </div>
            </div>




            <div class="sm_kk" id="saoma" v-if="!switchLoginType && !timeOut">




              <div class="ewm_cg" v-loading="loading">
                <img :src="'data:image/png;base64,' + codeImg" v-if="codeImg">
                <span class="smxx" v-if="smSuccess"><i class="icon iconfont icon-choose1"></i>
                  <div @click="getCode" style="cursor:pointer;">
                    <span class="wz">扫码成功</span>
                    <span class="wz02">请在微信里一键登录账号</span>
                    <span class="wz03"><i class="icon iconfont icon-refresh1"></i>重新扫码</span>
                  </div>

                </span>
              </div>

              <div class="smcg_text">
                <!--<span class="ts03"><i class="icon iconfont icon-refresh1"></i>重新扫码</span>-->
                <span class="ts01"><i class="icon iconfont icon-weixin2" ></i>微信扫码登录</span>
              </div>
            </div>


            <!--扫码登录 end-->







            <div class="login_llq clearfix" style="padding-top:30px;">
              <div>
                <h3 onclick="tishi()">登录系统后，可生成错题本和下载分析报告</h3>
                <!--<ul class="clearfix">
								
								<li class="w7"><span>1、打印错题本</span></li>
								<li class="xp" ><span>2、下载分析报告</span></li>
							</ul>-->
              </div>
            </div>






          </div>
        </div>


      </div>
    </div>

    <div class="user_footer">
      <div class="user_foot_info" style="position:relative; width:1200px; margin:0px auto;">

        <p>版权所有Copyright @ 2023 www.360ping.com All rights reserved</p>
        <p><a href="https://beian.miit.gov.cn/" target="_blank">蜀ICP备10000723号-2</a></p>

        <div class="bm_ma02">
          <span><img src="https://www.360ping.com/images/wx_gzh.png"><em>关注公众号</em></span>
          <span><img src="https://www.360ping.com/images/wx_xcx.png"><em>扫码使用系统</em></span>
      </div>

      </div>
    </div>
  </div>
</template>

<script>
import {
  userPassLogin,
  queryQrCode,
  getUserFggPwd,
  loginAjax,
  queryReportList,
  queryLoginQrCode,
  wxScanCheck
} from "../api/request";
export default {
  name: 'HelloWorld',
  data() {
    return {
      timeOut: false,
      switchLoginType: false,
      text: '',
      pwd: '',
      codeImg: '',
      time1: '',
      time2: '',
      uuid: '',
      smSuccess: false,
      loading:true,
    }
  },
  mounted() {
    this.getCode();

  },
  methods: {
    loginFgg() {

      getUserFggPwd().then((res) => {
        if (res.data.code == 200) {
          if (res.data.data) {
            // 分高高模拟登录......
            loginAjax({ userName: res.data.data.tel, passWord: res.data.data.pwd, source: 15 }).then((res_s) => {
              this.$router.push('/')
            })
          }
        } else {
          Toast(res.data.msg);
        }
      })
    },
    getCode() {
      if (this.time1) {
        clearInterval(this.time1);
      }
      if (this.time2) {
        clearTimeout(this.time2);
      }
      this.timeOut = false, this.smSuccess = false;
      queryLoginQrCode().then((res) => {
        if (res.data.code == 200) {
          this.codeImg = res.data.data;
          this.uuid = res.data.msg;
          this.time1 = setInterval(() => {
            this.handleWxScanCheck(res.msg, res.data);
          }, 500);
          this.time2 = setTimeout(() => {
            this.timeOut = true;
            clearInterval(this.time1);
          }, 60000);
        }
        this.loading=false;
      })
    },
    handleWxScanCheck() {
      wxScanCheck({ uuid: this.uuid }).then((res) => {
        if (res.data.code == 200) {
          if (res.data.data) {
            this.smSuccess = true;
            clearTimeout(this.time2);
            clearInterval(this.time1);
          }
          if (!!res.data.data && res.data.data.status == 1) {
            this.text=res.data.data.tel,this.pwd=res.data.data.pwd;
            this.confirmLogin();
          }
        }
      })
    },
    confirmLogin() {
      userPassLogin({ tel: this.text, pwd: this.pwd }).then((res) => {
        if (res.data.code == 200) {
          this.loginFgg();

        } else {
          this.$message({
            showClose: true,
            message: res.data.msg,
            type: 'error'
          });
        }
        console.log(res);
      })

    }
  }
}
</script>

<style scoped>
@import url("../assets/login.css");
@import url("../assets/public_style.css");
.bm_ma02{ position:absolute; top:-10px; right:0px; width:300px; text-align:right;}
 .bm_ma02>span{ display:inline-block; margin-left:40px;}
 .bm_ma02 img{ width:100px; display:block; clear:both; border-radius:5px; border:2px solid #2aad67;}
 .bm_ma02 em{ display:block; clear:both; text-align:center;}

.sm_kk div.ewm_cg .smxx{
    height: 160px;
    padding-top: 20px;
}
.sm_ewm_gq{
  width: 170px;
    height: 170px;
}
.sm_ewm_gq span {
    padding-left: 0px;
    padding-right: 0px;
}
.wid_con {
  max-width: 1200px;
  width: 100%;
  overflow: hidden;
  margin: 0 auto;
  padding-top: 10px;
}

.top_logo {
  float: left;
  margin: 15px 0;
}

.top_logo a {
  display: inline-block;
  vertical-align: middle;
  margin-right: 16px;
  width: 200px;
  height: 50px;
}

a {
  color: #666;
}

.top_logo span {
  display: inline-block;
  vertical-align: middle;
  border-left: #2aad67 solid 1px;
  font-size: 24px;
  color: #2aad67;
  height: 50px;
  line-height: 50px;
  padding-left: 20px;
}

.top_logo img {
  display: block;
  width: 200px;
}


.login-wrap .wrap {
  max-width: 1200px;
  height: 480px;
  padding: 0 100px;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/components/login.vue